export default "__VITE_ASSET__f9e1726e__"